import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GenericTable from 'componentes/generic/GenericTable.js';
import React from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const FormatosQuejaTable = ({
  setIdFormatosQueja,
  setOpenModal,
  formatosQueja
}) => {
  const columns = [
    {
      accessorKey: 'idformatoqueja',
      header: '#',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'formato',
      header: 'Formatos Queja',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'idformatoqueja',
      header: '',
      disableSortBy: true,
      cellProps: {
        className: 'text-end'
      },
      cell: ({ row: { original } }) => {
        const { idformatoqueja } = original;

        return (
          <>
            <Button
              variant="falcon-default"
              size="sm"
              title="Editar"
              onClick={() => {
                setIdFormatosQueja(idformatoqueja);
                setOpenModal(true);
              }}
            >
              <FontAwesomeIcon icon="pencil-alt" />
            </Button>
            {/* <Button
                      variant="falcon-default"
                      size="sm"
                      title="Eliminar"
                      onClick={() => {
                        setIdMunicipioToDelete(idmunicipio);
                        setOpenConfirm(true);
                      }}
                    >
                      <FontAwesomeIcon icon="trash-alt" />
                    </Button> */}
          </>
        );
      }
    }
  ];
  return (
    <>
      <GenericTable
        data={formatosQueja}
        columns={columns}
        title="Formatos Queja"
        addAction={() => {
          setIdFormatosQueja(0);
          setOpenModal(true);
        }}
      ></GenericTable>
    </>
  );
};

FormatosQuejaTable.propTypes = {
  formatosQueja: PropTypes.array.isRequired,
  setIdFormatosQueja: PropTypes.func.isRequired,
  setOpenModal: PropTypes.func.isRequired
};
export default FormatosQuejaTable;
